import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

enum GTMEvent {
    COMPARE_MODAL = "compare_modal",
    COMPARE_EVENTS = "compare_events"
}

export enum ComparisonToolGTMModalAction {
    BUTTON_CLICK = "button_click",
    CLOSE = "close",
    VIEW = "view"
}

const modalEvent = (action: ComparisonToolGTMModalAction) => {
    const eventData = {event: GTMEvent.COMPARE_MODAL, action};

    hitGoogleTagManager(eventData);
};

export enum ComparisonToolGTMTableAction {
    ADD_PROPERTY_CLICK = "add_property_click",
    LEFT_ARROW_CLICK = "left_arrow_click",
    RIGHT_ARROW_CLICK = "right_arrow_click",
    PHONE_REVEAL = "phone_reveal",
    PDF_DOWNLOAD = "pdf_download",
    SHOW_PROJECTION_CLICK = "show_projection_click",
    ADD_NEW_PROPERTY = "add_new_property",
    ADD_OWN_LOCATION = "add_own_location",
    USE_NOTE = "use_note"
}

const tableEvent = (action: ComparisonToolGTMTableAction) => {
    const eventData = {event: GTMEvent.COMPARE_EVENTS, action};

    hitGoogleTagManager(eventData);
};

export const comparisonToolAnalytics = {
    gtm: {
        modalEvent,
        tableEvent
    }
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

enum GTMEvent {
    COMPARE_MODAL = "compare_modal",
    COMPARE_EVENTS = "compare_events"
}

export enum ComparisonToolGTMModalAction {
    BUTTON_CLICK = "button_click",
    CLOSE = "close",
    VIEW = "view"
}

const modalEvent = (action: ComparisonToolGTMModalAction) => {
    const eventData = {event: GTMEvent.COMPARE_MODAL, action};

    hitGoogleTagManager(eventData);
};

export enum ComparisonToolGTMTableAction {
    ADD_PROPERTY_CLICK = "add_property_click",
    LEFT_ARROW_CLICK = "left_arrow_click",
    RIGHT_ARROW_CLICK = "right_arrow_click",
    PHONE_REVEAL = "phone_reveal",
    PDF_DOWNLOAD = "pdf_download",
    SHOW_PROJECTION_CLICK = "show_projection_click",
    ADD_NEW_PROPERTY = "add_new_property",
    ADD_OWN_LOCATION = "add_own_location",
    USE_NOTE = "use_note"
}

const tableEvent = (action: ComparisonToolGTMTableAction) => {
    const eventData = {event: GTMEvent.COMPARE_EVENTS, action};

    hitGoogleTagManager(eventData);
};

export const comparisonToolAnalytics = {
    gtm: {
        modalEvent,
        tableEvent
    }
};
